import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const LINKS = [
  { to: "/sell-diabetic-test-strips/", title: "Sell Diabetic Test Strips for Cash", desc: "Full process, requirements, and how to get started" },
  { to: "/how-to-sell-unused-diabetic-test-strips/", title: "How to Sell Unused Diabetic Test Strips", desc: "A plain step-by-step guide for first-time sellers" },
  { to: "/where-to-sell-diabetic-test-strips/", title: "Where to Sell Diabetic Test Strips", desc: "Local vs mail-in vs marketplace options compared" },
  { to: "/who-buys-diabetic-supplies-near-me/", title: "Who Buys Diabetic Supplies Near Me?", desc: "Local buyer for eligible unused diabetic supplies" },
  { to: "/accepted-diabetic-supplies/", title: "Accepted Diabetic Supplies", desc: "Full brand and product list with eligibility rules" },
  { to: "/sell-diabetic-supplies-jacksonville-fl/", title: "Sell Diabetic Supplies in Jacksonville, FL", desc: "How the local, in-person process works" },
  { to: "/how-much-are-diabetic-test-strips-worth/", title: "How Much Are Diabetic Test Strips Worth?", desc: "The factors that affect value and how we quote" },
  { to: "/sell-medtronic-supplies/", title: "Sell Eligible Medtronic Supplies", desc: "Specific Medtronic products we currently accept" },
];

export const ResourceLinks = () => (
  <section className="py-16 md:py-20 bg-white" data-testid="resource-links-section">
    <div className="container-custom">
      <div className="text-center mb-10">
        <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-[#1F2937] mb-3" style={{ fontFamily: "Manrope" }}>
          Learn More Before You Sell
        </h2>
        <p className="text-lg text-[#4B5563] max-w-2xl mx-auto">
          Detailed guides on eligibility, pricing factors, and specific brands we accept.
        </p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {LINKS.map((l) => (
          <Link
            to={l.to}
            key={l.to}
            className="group block bg-[#F5F5F0] hover:bg-[#0F5132] hover:text-white rounded-xl p-6 transition-colors"
            data-testid={`resource-link-${l.to.replace(/\//g, '')}`}
          >
            <h3 className="font-semibold text-lg mb-2 text-[#1F2937] group-hover:text-white" style={{ fontFamily: "Manrope" }}>
              {l.title}
            </h3>
            <p className="text-sm text-[#4B5563] group-hover:text-white/90 mb-3">{l.desc}</p>
            <span className="inline-flex items-center gap-1 text-sm font-semibold text-[#EA580C] group-hover:text-white">
              Read more <ArrowRight className="w-4 h-4" />
            </span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);
